import { CreateVariantsFromTemplateFormValues } from "./types";
import { defaultFormValues, schema } from "./constants";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface CreateVariantsFromTemplateFormProviderProps {
  defaultValues?: Partial<CreateVariantsFromTemplateFormValues>;
  children?: React.ReactNode;
}

export const CreateVariantsFromTemplateFormProvider = ({
  defaultValues,
  children,
}: CreateVariantsFromTemplateFormProviderProps) => {
  const normalizedDefaultValues: Partial<CreateVariantsFromTemplateFormValues> =
    React.useMemo(() => {
      return {
        ...defaultFormValues,
        ...defaultValues,
      };
    }, []);

  const methods = useForm<CreateVariantsFromTemplateFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: normalizedDefaultValues,
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
